export const isMockApiEnabled = () => {
  const mockApi = localStorage.getItem('mockApi');
  return mockApi === null ? false : JSON.parse(mockApi);
};

export const disableMockApi = () => {
  localStorage.setItem('mockApi', 'false');
  window.location.reload();
};
